/* MM: Produktfaner + jevn scroll fra «Les mer om produktet» (malen product-test) */
(() => {
  if (customElements.get('mm-product-tabs')) return;

  class MmProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('is-active', active);
        if (this.panels[i]) this.panels[i].hidden = !active;
      });
      if (focus) this.tabs[index].focus();
      // «Les mer» må måles på nytt når panelet blir synlig
      this.panels[index]?.querySelectorAll('product-description-expand').forEach((el) => {
        if (typeof el._syncOverflow === 'function') requestAnimationFrame(() => el._syncOverflow());
      });
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      if (next !== null) {
        event.preventDefault();
        this.select(next, true);
      }
    }
  }

  customElements.define('mm-product-tabs', MmProductTabs);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-mm-scroll-to]');
    if (!link) return;
    const target = document.getElementById(link.dataset.mmScrollTo);
    if (!target) return;
    event.preventDefault();
    target.querySelector('mm-product-tabs')?.select(0);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();
